enum CampusCardAccountType {
  StoredValue = 'stored-value',
  MealPlan = 'meal-plan',
  CashEquivalency = 'cash-equivalency',
}

export { CampusCardAccountType };
